import { mixed, object } from 'yup';

export const validationSchema = object({
  case: mixed().test('is-object-or-null', 'Musisz wybrać teczkę żeby utworzyć czynność', value => {
    return value !== null;
  })
});